import React from 'react'
import { useTranslation } from 'react-i18next';

// MUI
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';

// Custom
import DialogToolbarHeading from '@/ui/Dialog/DialogToolbarHeading';
import DraggableDialog from '@/ui/Dialog/DraggableDialog'
import DialogToolbarButtonClose from '@/ui/Dialog/ToolbarButtons/DialogToolbarButtonClose';
import ToolbarFillContent from '@/ui/Toolbar/ToolbarFillContent';

import { IDialogProps } from '@/context/DialogContext/DialogContext';


const GSInfoDialog = (props: IDialogProps) => {

  const { t } = useTranslation();

  const { handleClose, body, identifier, FormContent } = props;

  return (
    <DraggableDialog PaperProps={{
      sx: {
        margin: {
          xs: "32px 0px",
          md: "32px"
        },
        maxWidth: {
          xs: "100%",
          md: "900px"
        },
        width: {
          xs: "100%",
          md: "calc(100% - 64px)"
        },
      }
    }} maxWidth='md' open >
      <DialogTitle>
        <Toolbar variant="dense" disableGutters>
          <DialogToolbarHeading>{t(`map:titles.gsinfocard.${identifier}`)}</DialogToolbarHeading>
          <ToolbarFillContent />
          <DialogToolbarButtonClose onClick={handleClose} />
        </Toolbar>
      </DialogTitle>
      <DialogContent sx={{ p: 0, width: "100%" }}>
        <Box sx={{ mx: { xs: 1, md: 2 }, mt: { xs: 1, md: 2 } }}>
          {FormContent}
        </Box>
        {body}
      </DialogContent>
    </DraggableDialog>
  )
}

export default GSInfoDialog;